<!-- Skeleton state -->
@if (isLoading) {
  <div class="bg-white rounded-3xl shadow-sm border border-stone-100 overflow-hidden px-6 py-5">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
      <div class="h-32 animate-pulse bg-stone-100 rounded-2xl"></div>
      <div class="h-32 animate-pulse bg-stone-100 rounded-2xl"></div>
    </div>
  </div>
}

<!-- Loaded state -->
@if (!isLoading) {
  <div class="bg-white rounded-3xl shadow-sm border border-stone-100 overflow-hidden px-6 py-5">
    <div class="grid grid-cols-1 gap-5" [ngClass]="showGender ? 'md:grid-cols-2' : 'md:grid-cols-1'">

      <!-- Left panel — Gender breakdown (players only) -->
      @if (showGender) {
        <div class="rounded-2xl bg-stone-50 border border-stone-100 p-4">
          <div class="flex items-center justify-between gap-3">
            <p class="text-stone-500 text-xs font-medium">{{ entityLabel }}</p>
            <div class="flex items-center gap-2">
              <span class="text-[10px] font-bold text-sky-700 bg-sky-50 border border-sky-100 px-2 py-0.5 rounded-full">
                {{ hommePct() }}
              </span>
              <span class="text-[10px] font-bold text-pink-700 bg-pink-50 border border-pink-100 px-2 py-0.5 rounded-full">
                {{ femmePct() }}
              </span>
            </div>
          </div>
          <div class="flex items-end justify-between gap-4 mt-2">
            <p class="text-4xl font-bold text-stone-900 leading-none">{{ total }}</p>
            <p class="text-xs text-stone-400">Total</p>
          </div>
          <div class="mt-4 h-3 rounded-full bg-white border border-stone-200 overflow-hidden flex">
            <div class="h-full bg-sky-400" [style.width]="hommePct()"></div>
            <div class="h-full bg-pink-400" [style.width]="femmePct()"></div>
          </div>
          <div class="mt-4 grid grid-cols-2 gap-3">
            <div class="rounded-xl bg-white border border-stone-200 px-3 py-2">
              <p class="text-xs text-stone-400">Hommes</p>
              <p class="text-lg font-bold text-sky-700 font-mono">{{ totalHommes }}</p>
            </div>
            <div class="rounded-xl bg-white border border-stone-200 px-3 py-2">
              <p class="text-xs text-stone-400">Femmes</p>
              <p class="text-lg font-bold text-pink-700 font-mono">{{ totalFemmes }}</p>
            </div>
          </div>
        </div>
      }

      <!-- Right panel — Status breakdown -->
      <div class="rounded-2xl bg-stone-50 border border-stone-100 p-4">
        <div class="flex items-center justify-between gap-3">
          <p class="text-stone-500 text-xs font-medium">{{ showGender ? 'Statuts' : entityLabel }}</p>
          <span class="text-[10px] font-bold text-stone-700 bg-stone-100 border border-stone-200 px-2 py-0.5 rounded-full">
            {{ total }}
          </span>
        </div>
        <div class="mt-3 grid grid-cols-2 gap-3">
          @for (item of statusItems; track item.statusCode) {
            <div class="rounded-xl bg-white border border-stone-200 px-3 py-2 flex items-center justify-between">
              <span class="inline-flex items-center gap-2 text-xs text-stone-500">
                <span class="w-1.5 h-1.5 rounded-full" [style.backgroundColor]="dotColor(item)"></span>
                {{ item.label }}
              </span>
              <span class="text-xs font-bold font-mono" [style.color]="textColor(item)">{{ item.count }}</span>
            </div>
          }
        </div>
        @if (statusItems.length > 0) {
          <div class="mt-4 h-2 rounded-full bg-white border border-stone-200 overflow-hidden flex">
            @for (item of statusItems; track item.statusCode) {
              <div class="h-full" [style.backgroundColor]="barColor(item)" [style.width]="pct(item.count)"></div>
            }
          </div>
        }
      </div>

    </div>
  </div>
}
